import {gql, useMutation} from '@apollo/client';
import {ActiveGame} from "../types/nbaTypes";
import {SdqlSummaryData, Sport} from "../types/types";
import {useLocation} from "react-router-dom";

const REFETCH_DEFAUL_TRENDS = gql`
    query GetDefaultTrends($sport: String!) {
        defaultTrends(sport: $sport) {
            id
            trend
        }
    }
`;

const SAVE_TREND = gql`    
    mutation Mutation(
            $trend: String, 
            $isSuTrend: Boolean,
            $isAtsTrend: Boolean,
            $isOuTrend: Boolean,
            $isDefaultTrend: Boolean,
            $isDefaultUserTrend: Boolean,
            $sport: String,
            $sdqlSummaryData: SdqlSummaryDataInput
            $description: String,
            $activeGames: [ActiveGameInput!],
            $trendId: String,
        ) {
      saveTrend(
            trend: $trend,
            isSuTrend: $isSuTrend,
            isAtsTrend: $isAtsTrend,
            isOuTrend: $isOuTrend,
            isDefaultTrend: $isDefaultTrend,
            isDefaultUserTrend: $isDefaultUserTrend,
            sport: $sport,
            sdqlSummaryData: $sdqlSummaryData,
            description: $description
            activeGames: $activeGames,
            trendId: $trendId,
        ) {
        id
        trend
      }
    }
`;

export const useSaveTrend = () => {
    const [executeMutation, {data, loading, error, reset}] = useMutation(SAVE_TREND);
    const {pathname, search} = useLocation()
    let refetchToUse = 'GetNflMatchups';
    if(pathname.includes('ncaafb')) refetchToUse = 'GetNcaafbMatchups'
    if(pathname.includes('ncaabb')) refetchToUse = 'GetNcaabbMatchups'
    if(pathname.includes('nba')) refetchToUse = 'GetNbabMatchups'

    const saveTrend = (
        trend: string,
        isSuTrend: boolean,
        isAtsTrend: boolean,
        isOuTrend: boolean,
        isDefaultTrend: boolean,
        isDefaultUserTrend: boolean,
        sport: Sport,
        sdqlSummaryData?: SdqlSummaryData,
        description?: string,
        activeGames?: ActiveGame[],
        trendId?: string,
    ) => {
        const sanitizedSdqlSummaryData = sdqlSummaryData
            ? Object.fromEntries(Object.entries(sdqlSummaryData).filter(([key]) => key !== "__typename"))
            : undefined;

        return executeMutation({
            variables: {
                trend,
                isSuTrend,
                isAtsTrend,
                isOuTrend,
                isDefaultTrend,
                isDefaultUserTrend,
                sport,
                sdqlSummaryData: sanitizedSdqlSummaryData, // Use sanitized version
                description,
                activeGames,
                trendId,
            },
            refetchQueries: [
                'GetUserTrends',
                refetchToUse,
                {
                    query: REFETCH_DEFAUL_TRENDS,
                    variables: { sport },
                },
            ],
            errorPolicy: 'all',
        });
    };

    return {saveTrend, data, loading, error, reset};
};